import { fetch } from '../../utils';
import Backend from '../../backend';

export const getFunctions = async () =>
  fetch(Backend.methodUrl('functions'))
    .then(res => {
      return res.json();
    })
    .then(payload => {
      return payload;
    })
    .catch(error => {
      throw error;
    });

export const getLpInfo = async (id, locale) =>
  fetch(Backend.api('lpInfo') + `?id=${id}&l=${locale}`)
    .then(res => {
      return res.json();
    })

